import { t } from './i18n';

const priceFormatter = new Intl.NumberFormat('nl-NL');

// Mirrors the backend price template: v.o.n. always suffixes, an indicative
// price gets a prefix, no price at all reads "Prijzen nog niet bekend". Shared
// by the listing card and the map card so a home never shows two price lines.
export const listingPrice = ({ definitivePrice, indicativePrice }) => {
  const amount = definitivePrice || indicativePrice;
  if (!amount) return { prefix: '', value: t('listing-card.price-on-request'), suffix: '' };
  return {
    prefix: definitivePrice ? '' : t('listing-card.price.indicative-prefix'),
    value: `€ ${priceFormatter.format(amount)}`,
    suffix: t('listing-card.price.suffix')
  };
};

// A numeric layer reads as an ordinal ("1e"); the CMS also holds words like
// "begane grond", which must not get the suffix
const layerLabel = (layer) => (Number.isFinite(Number(layer)) ? `${layer}e` : String(layer));

// Status vocabulary of a home: the two statuses with a colour of their own
export const listingStatusModifier = (status) => ({
  'is-available': status === 'Beschikbaar',
  'is-option': status === 'In optie'
});

// The API sends every phase status; only the registration window, which is
// time-boxed, earns a label on a home card
const REGISTRATION_PHASE_STATUSES = ['Inschrijving', 'Voorinschrijving'];

export const registrationPhaseLabel = (subProjectStatus) =>
  REGISTRATION_PHASE_STATUSES.includes(subProjectStatus) ? subProjectStatus : null;

// Design order Wonen | Slaapk. / Woonlaag | Energielabel; parcel area fills an
// empty layer slot.
export const listingSpecs = ({ livingArea, layer, parcelArea, bedrooms, energyLabel }) => {
  let layerSpec = null;
  if (layer) layerSpec = { label: t('listing-card.spec.layer'), value: layerLabel(layer) };
  else if (parcelArea) layerSpec = { label: t('listing-card.spec.parcel'), value: `${parcelArea} m²` };

  return [
    livingArea ? { label: t('listing-card.spec.living'), value: `${livingArea} m²` } : null,
    Number.isFinite(bedrooms) ? { label: t('listing-card.spec.bedrooms'), value: bedrooms } : null,
    layerSpec,
    energyLabel ? { label: t('listing-card.spec.energy'), value: energyLabel } : null
  ].filter(Boolean);
};
